module.exports = __webpack_public_path__ + "static/media/scr_simple.f9552d6b.png";